export default function ActionsFooter({
  onMoodClick,
  onSkinClick,
  onFeedbackClick,
  onHelpClick,
  onStudioClick,
  studioUrl = null,
  activeSheet = null,
  hiddenActions = [],
}) {
  const shows = (kind) => !hiddenActions.includes(kind);
  const linkClass = (kind, extra) =>
    [extra, activeSheet === kind && "actions__link--active"]
      .filter(Boolean)
      .join(" ") || undefined;

  return (
    <div className="actions">
      <div className="actions__list">
        {shows("mood") && (
          <a
            href="#!"
            className={linkClass("mood")}
            aria-current={activeSheet === "mood" ? "true" : undefined}
            onClick={(event) => {
              event.preventDefault();
              onMoodClick?.();
            }}
          >
            Moods
          </a>
        )}
        {shows("skin") && (
          <a
            href="#!"
            className={linkClass("skin")}
            aria-current={activeSheet === "skin" ? "true" : undefined}
            onClick={(event) => {
              event.preventDefault();
              onSkinClick?.();
            }}
          >
            Skins
          </a>
        )}
        {shows("help") && (
          <a
            href="#!"
            className={linkClass("help")}
            aria-current={activeSheet === "help" ? "true" : undefined}
            onClick={(event) => {
              event.preventDefault();
              onHelpClick?.();
            }}
          >
            Advanced
          </a>
        )}
        {shows("feedback") && (
          <a
            href="#!"
            className={linkClass("feedback")}
            aria-current={activeSheet === "feedback" ? "true" : undefined}
            onClick={(event) => {
              event.preventDefault();
              onFeedbackClick?.();
            }}
          >
            Feedback
          </a>
        )}
        {/* Studio is the special item: a tag, not one more plain link. The
            label carries the tag so the row's dot stays outside it. */}
        {shows("studio") && studioUrl && (
          <a
            href="#!"
            className={linkClass("studio", "actions__tag")}
            aria-current={activeSheet === "studio" ? "true" : undefined}
            onClick={(event) => {
              event.preventDefault();
              onStudioClick?.();
            }}
          >
            <span className="actions__tag-label">Studio</span>
          </a>
        )}
      </div>
    </div>
  );
}
